import React from "react";
import { Icon } from "@chakra-ui/react";

export const ArrowRightLongIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 11L16.17 11L10.58 5.41L12 4L20 12L12 20L10.59 18.59L16.17 13L4 13V11Z"
        fill="#004D99"
      />
    </Icon>
  );
};
